import { RecognitionManager } from '@descomplica/microfrontend-core';
import { action, makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import { GetIdentifiedUserCollaboration } from '@/application/collaborations/get-identified-user.collaboration';
import type { UserDto } from '@/application/interfaces/pegasus.gateway';

@singleton()
export class UserModel {
  @observable user: UserDto;
  @observable hasPermissionError: boolean;

  constructor(
    private readonly recognitionManager: RecognitionManager,
    private readonly getIdentifiedUserCollaboration: GetIdentifiedUserCollaboration,
  ) {
    makeObservable(this);
  }

  @action
  async getIdentifiedAccount() {
    try {
      const { data: user } = await this.getIdentifiedUserCollaboration.run();
      this.user = user;
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        this.hasPermissionError = true;
        return;
      }
      throw error;
    }
  }

  @action
  async clearAccount() {
    try {
      await this.recognitionManager.clearCredentials();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
